export const normalizeAttendee = attendee =>
	JSON.stringify({
		...attendee,
		id: +attendee.id,
		client_metadata: JSON.stringify(attendee.client_metadata),
	});

export const parseAttendee = attendee => {
	return {
		...attendee,
		client_metadata: JSON.parse(attendee.client_metadata || '{}'),
	};
};

export const parseMetaDeta = metadata => {
	const { custom_metadata_fields, custom_metadata_attributes } = metadata;
	const data = metadata.metadata ? JSON.parse(metadata.metadata) : {};

	const fields = custom_metadata_fields ? JSON.parse(custom_metadata_fields) : [];
	// let attributes = custom_metadata_attributes
	// 	? custom_metadata_attributes.reduce((acc, attr) => {
	// 			if (attr.key) {
	// 				acc[attr.key] = attr;
	// 			}
	// 			return acc;
	// 	  }, {})
	// 	: {};
	let attributes = custom_metadata_attributes ? custom_metadata_attributes : [];

	return { data, fields, attributes };
};
